import { Rocket, Wrench } from 'lucide-react';
import { HubPageLayout, SettingsRowDef } from './HubPageLayout';

export function IomiSystemHubPage() {
  const rows: SettingsRowDef[] = [
    {
      id: 'app-versions',
      label: 'App Versions & Releases',
      desc: 'Manage platform versions, force-update gates, and publish release notes.',
      icon: Rocket,
      path: '/admin/platform-tools/app-versions',
    },
    {
      id: 'developer-tools',
      label: 'Developer Tools',
      desc: 'Configure third-party integrations and app-level settings.',
      icon: Wrench,
      path: '/admin/platform-tools/developer-tools',
    },
  ];

  return (
    <HubPageLayout
      title="System & Developer"
      subtitle="App versions, releases, and developer tools."
      rows={rows}
      backPath="/admin/platform-tools"
      backLabel="Platform Admin Tools"
    />
  );
}
